import React, { useEffect, useState } from "react";
import {
  createNewStatus,
  deleteStatus,
  getIUCNStatus,
  updateStatus,
} from "../../api/iucnstatus/iucnstatusApi";
import { IUCNStatus } from "../common/ObjectTypes";
import IUCNStatusController from "./IUCNStatusList";
import { toast } from "react-toastify";

const ManageIUCNStatusController = () => {
  const [pageLoaded, setPageLoaded] = useState(false);
  const [iucnStatuses, setIucnStatuses] = useState<IUCNStatus[]>([]);
  const [addStatus, setAddStatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<IUCNStatus>({
    name: "",
    id: "",
    description: "",
    rowVersion: "",
  });
  const [statusToAdd, setStatusToAdd] = useState<IUCNStatus>({
    name: "",
    id: "",
    description: "",
    rowVersion: "",
  });

  useEffect(() => {
    const loadStatuses = async () => {
      try {
        const temp = await getIUCNStatus();
        setIucnStatuses(temp);
        setPageLoaded(true);
      } catch (error) {
        console.log(error);
      }
    };
    if (!pageLoaded) loadStatuses();
  }, [pageLoaded]);

  const handleOnClickAdd = () => {
    setAddStatus(true);
  };

  const handleSelectStatus = (iucnStat: IUCNStatus) => {
    setSelectedStatus({
      id: iucnStat.id,
      description: iucnStat.description,
      name: iucnStat.name,
      rowVersion: iucnStat.rowVersion,
    });
  };

  const handleChange = (e: any) => {
    const name = e.target.name;
    if (name === "name") {
      setSelectedStatus((prev: IUCNStatus) => ({
        ...prev,
        name: e.target.value,
      }));
    } else if (name === "description") {
      setSelectedStatus((prev: IUCNStatus) => ({
        ...prev,
        description: e.target.value,
      }));
    }
  };

  const handleChangeNewStatus = (e: any) => {
    const name = e.target.name;

    if (name === "name") {
      setStatusToAdd((prev: IUCNStatus) => ({
        ...prev,
        name: e.target.value,
      }));
    } else if (name === "description") {
      setStatusToAdd((prev: IUCNStatus) => ({
        ...prev,
        description: e.target.value,
      }));
    }
  };

  const handleUpdateStatus = async () => {
    try {
      await updateStatus(selectedStatus);
      toast.success("IUCN Status updated.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveNew = async () => {
    try {
      await createNewStatus({
        name: statusToAdd.name,
        description: statusToAdd.description,
      });
      toast.success(statusToAdd.name + " added.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setAddStatus(false);
      setStatusToAdd(() => ({
        id: "",
        name: "",
        description: "",
      }));
      setPageLoaded(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancelEdit = () => {
    setSelectedStatus({
      name: "",
      id: "",
      description: "",
      rowVersion: "",
    });
  };

  const handleDelete = async () => {
    try {
      await deleteStatus(selectedStatus.id ? selectedStatus.id : "");
      setSelectedStatus({
        name: "",
        id: "",
        description: "",
        rowVersion: "",
      });
      toast.success("Status was deleted.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelAdd = () => {
    setAddStatus(false);
  };

  return (
    <div className="h-full">
      <IUCNStatusController
        iucnStatuses={iucnStatuses}
        selectedStatus={selectedStatus}
        statusToAdd={statusToAdd}
        addStatus={addStatus}
        onSelectStatus={handleSelectStatus}
        onChange={handleChange}
        onChangeNewStatus={handleChangeNewStatus}
        onClickAdd={handleOnClickAdd}
        onCancelEdit={handleCancelEdit}
        onCancelAdd={handleCancelAdd}
        onSaveNew={handleSaveNew}
        onUpdateStatus={handleUpdateStatus}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default ManageIUCNStatusController;
